import { Switch, Route, Redirect } from 'react-router-dom';
import Balcao from '../pages/Balcao';
import NotFound from '../pages/NotFound';
import Unauthorized from '../pages/Unauthorized';

const Routes: React.FC = () => {
  return (
    <Switch>
      <Route exact path="/">
        <Redirect to="/balcao/:id" />
      </Route>
      <Route path="/balcao/:id" exact component={Balcao} />
      <Route path="/unauthorized" component={Unauthorized} />
      <Route path="*" component={NotFound} />
    </Switch>
  );
};

export default Routes;
